import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=48edb71b&scoped=true"
import script from "./OrderDetail.ts?vue&type=script&lang=ts&external"
export * from "./OrderDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./order-detail.scss?vue&type=style&index=0&id=48edb71b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edb71b",
  null
  
)

export default component.exports